import React from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import OutsideAlerter from 'shared/components/outside-alerter/outside-alerter';

import MultiSelectOrganisationTree from './components/multi-select-organisation-tree/multi-select-organisation-tree';
import useFilterChipOrganizationUnit, { FilterChipOrganizationUnitProps } from './hooks/index';

import './organisation-unit-filter-chip.scss';

const OrganisationUnitFilterChip = ({
  onOptionsSelected,
  placeHolder,
  selectedOptions,
  locationsOnly,
  initialVisibleOrganisationUnitId,
}: Readonly<FilterChipOrganizationUnitProps>): React.JSX.Element => {
  const { isOpen, closeIsOpen, toggleIsOpen, onSelectOrganizationUnit, getLabel } = useFilterChipOrganizationUnit({
    onOptionsSelected,
    placeHolder,
    selectedOptions,
    locationsOnly,
  });

  return (
    <OutsideAlerter funcDelegate={closeIsOpen}>
      <div className="filter-chip filter-chip-organisation-unit">
        <Chip
          data-testid={`filterChip${placeHolder}`}
          label={getLabel()}
          variant="outlined"
          clickable
          deleteIcon={<ArrowDropDownIcon />}
          onDelete={toggleIsOpen}
          onClick={toggleIsOpen}
          className={`${selectedOptions.length === 0 ? '' : 'active'}`}
        />
        <Paper elevation={1} className={`options ${isOpen ? '' : 'hidden'}`}>
          <MultiSelectOrganisationTree
            locationsOnly={locationsOnly}
            onSelectOrganisationUnit={onSelectOrganizationUnit}
            selectedOrganisationUnitIds={selectedOptions.map((x) => x.id)}
            initialVisibleOrganisationUnitId={initialVisibleOrganisationUnitId}
          />
        </Paper>
      </div>
    </OutsideAlerter>
  );
};

export default OrganisationUnitFilterChip;
